import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import LineClamp from '../LineClamp';
import theme, { cardTitle as categoryStyle } from '../../styles/theme';
import stylePlaceholders from '../../styles/placeholders';
import formatDate from '../../helpers/formatDate';

const Caption = ({
  category, classes, className, readTime, publishedDate, slug, title,
}) => (
  <div className={cn(className, classes.caption, !slug && classes.placeholder)}>
    <h4 className={classes.category}>
      {category}
      {publishedDate && (
        <span>
          <span className={classes.separator}>
            |
          </span>
          <span className={classes.publishedDate}>
            {formatDate(publishedDate)}
          </span>
        </span>
      )}
      {readTime && (
        <span>
          <span className={classes.separator}>
            |
          </span>
          <span className={classes.readTime}>
            {readTime}
          </span>
        </span>
      )}
    </h4>
    <LineClamp line={2}>
      <h3 className={classes.title}>
        {title}
      </h3>
    </LineClamp>
  </div>
);

export const captionPropTypes = {
  category: PropTypes.string,
  readTime: PropTypes.string,
  publishedDate: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
};

Caption.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  ...captionPropTypes,
};

export const captionDefaultProps = {
  category: undefined,
  readTime: undefined,
  publishedDate: undefined,
  slug: undefined,
  title: undefined,
};

Caption.defaultProps = {
  className: undefined,
  ...captionDefaultProps,
};

export default injectSheet({
  caption: {
    backgroundColor: theme.colors.white,
    padding: [theme.padding.gutter, 24],
  },
  category: {
    ...categoryStyle,
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.colors.ui02,
    letterSpacing: 0.3,
    marginBottom: 8,
    textTransform: 'uppercase',
    '& span': {
      textTransform: 'none',
      fontFamily: theme.fonts.body,
    },
  },
  separator: {
    margin: [0, '0.5em'],
  },
  title: {
    fontFamily: theme.fonts.bold,
    letterSpacing: 0.3,
    fontSize: 16,
    margin: 0,
    lineHeight: 1.5,
    minHeight: '2.7em',
    color: theme.colors.brandBlack,
  },
  ...stylePlaceholders({
    category: { dark: true, text: true, width: '10em' },
    title: { text: true, width: '90%' },
  }),
})(Caption);
